let config = {};

export const loadConfig = async () => {
    const response = await fetch('config.json');
    config = await response.json();
};

export const getConfig = (key, defaultValue = null) => {
    return config[key] || defaultValue;
};